export const INTERCOM_CONTROL = 'intercomShow';
